module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('explorer', {
    attrs: {
      "slug": _vm.random
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-cf666c7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Random.vue
// module id = 139
// module chunks = 1